import React, { PureComponent } from 'react';

import { copyUrlToClipboard } from '../utils';
import { buildAppUrl } from '../utils/url';

import Dropdown from './dropdown';

export default class DocShareDropdown extends PureComponent {
    handleSharePermissionClick = permission => {
        copyUrlToClipboard(buildAppUrl(`/document/${this.props.token}`));

        this.props.onShare && this.props.onShare();
    }

    render() {
        return (
            <Dropdown
                xAlign={this.props.xAlign}
                items={[
                    {
                        id: 'view',
                        text: 'View-only'
                    },
                    // {
                    //     id: 'comment',
                    //     text: 'View & comment'
                    // },
                    // {
                    //     id: 'edit',
                    //     text: 'View, comment & edit'
                    // }
                ]}
                provideController={this.props.provideController}
                onItemClick={this.handleSharePermissionClick}
            />
        )
    }
}